import ProjectItem from './ProjectItem/ProjectItem';
import style from './Projects.module.css';

const items = [
  {
    title: 'Online Dating',
    description:
      'DOL is a fully developed online dating platform designed for instant deployment. With a sleek user interface, real-time live chat, and high-quality video streaming, it provides a seamless dating experience. The platform includes a powerful admin panel for full control, ensuring smooth management and security.',
    image: 'https://dating-date-photos.s3.us-east-2.amazonaws.com/logoBig.png',
    link: 'https://datingcom.uk/',
  },
  {
    title: 'AI Assistance',
    description:
      'Our AI Assistance solution is a fully developed, ready-to-integrate system that enhances user engagement, automates support, and improves efficiency. Featuring real-time chat, intelligent responses, and seamless website integration, it provides a smarter way to interact with your visitors. With an intuitive admin panel, you have full control over AI behavior and customization.',
    image:
      'https://irp.cdn-website.com/0930f0fc/dms3rep/multi/Ai+Virtual+Assistants.png',
    link: 'https://t.me/TrustPolicyBot',
  },
];

const Projects = () => {
  return (
    <>
      <div className={style.projectsContainer} id="projects">
        <h1>Our Projects</h1>
        <div className={style.projects}>
          {items.map((item, i) => (
            <ProjectItem data={item} key={i} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Projects;
